export default __webpack_public_path__ + "static/media/211.ea11c747.png";